import React, { useEffect, useState, useContext } from "react";

import { languages } from "../../languages/languages";
import UserContext from "../../languages/UserContext";

import { LogoHouse, Phone, Mail } from "../svg/Svgs";
import classNames from "classnames";

import "./Navbar.scss";

const Navbar = ({ changeLanguageFunction }) => {
  const user = useContext(UserContext);

  const [scroll, setScroll] = useState(false);
  const [selected, setSelected] = useState(0);
  const [navOpen, setNavOpen] = useState(false);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (40 > currentScrollY && scroll) {
      setScroll(false);
    } else if (40 < currentScrollY && !scroll) {
      setScroll(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scroll]);

  useEffect(() => {
    if (navOpen) {
      window.removeEventListener("scroll", handleScroll);
      setScroll(true);
    } else if (!navOpen && window.scrollY > 40) {
      setScroll(true);
    } else if (!navOpen) {
      setScroll(false);
    } else if (navOpen && window.scrollY === 0) {
      setScroll(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navOpen, scroll]);

  const langPool = ["pl", "en", "ru", "uk"];
  const langOptions = langPool.map((lang, idx) => (
    <span
      key={idx}
      onClick={(e) => {
        changeLanguageFunction(e);
        setSelected(idx);
      }}
      className={classNames({
        "lang-option": !scroll && selected !== idx,
        "lang-option-dark lang-option-dark--down": scroll && selected !== idx,
        "lang-option-dark  lang-option-dark--selected nh":
          scroll && selected === idx,
        "lang-option lang-option--selected": !scroll && selected === idx,
        "lang-option-dark lang-option-dark--selected nb": scroll && navOpen,
      })}
    >
      {lang}
    </span>
  ));

  return (
    <div className={scroll ? "navbar navbar--down" : "navbar"}>
      <a href="#hero" className="logo-wrap">
        <LogoHouse colorOne={scroll ? "#121a27" : "#fff"}></LogoHouse>
      </a>

      <div className={`navbar-wrap ${navOpen ? "navbar-wrap--open" : ""}`}>
        <div className="lang">{langOptions}</div>
        <nav className={navOpen ? "navigation navigation--down" : "navigation"}>
          <a
            className="nav-link"
            onClick={() => {
              setNavOpen(false);
            }}
            href="#mission"
          >
            {languages[user.lang].About}
          </a>
          <a
            className="nav-link"
            onClick={() => {
              setNavOpen(false);
            }}
            href="#project"
          >
            {languages[user.lang].Portfolio}
          </a>
          <a
            className="nav-link"
            onClick={() => {
              setNavOpen(false);
            }}
            href="#construction"
          >
            {languages[user.lang].Services}
          </a>
          <a
            className="nav-link nav-link--hire"
            onClick={() => {
              setNavOpen(false);
            }}
            href="#contact"
          >
            {languages[user.lang].HireUs}
          </a>
        </nav>
        <div
          className={`nav-contacts ${!navOpen ? "nav-contacts--hidden" : ""}`}
        >
          <div className="contact-wrap">
            <div className="thumbnail">
              <Phone></Phone>
            </div>
            <div>
              <span>+48 574 477 778</span>
              <span>+48 733 677 084</span>
            </div>
          </div>
          <div className="contact-wrap">
            <div className="thumbnail">
              <Mail></Mail>
            </div>
            <a href="mailto:dreamh.y.a.k.@gmail.com">dreamh.y.a.k.@gmail.com</a>
          </div>
        </div>
      </div>
      <div
        className="hamburger-container"
        onClick={() => {
          setNavOpen(!navOpen);
        }}
      >
        <div
          className={`hamburger-icon ${navOpen ? "hamburger-icon--open" : ""} ${
            !scroll ? "hamburger-icon--white" : ""
          }`}
        >
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
